import React, { useState, useEffect } from "react";
import "./currentGuestTableForm.scss";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import CustomLoader from "../CustomLoader/CustomLoader";
import AllServices from "../../Services/AllServices";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ConfirmationCard from "../ConfirmationCard/ConfirmationCard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewDetails from "../ViewDetails/ViewDetails";
import { FrontEndURL, status } from "../../Constants/Constants";
import Tooltip from "@mui/material/Tooltip";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, intlFormat } from "date-fns";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useLocation } from "react-router-dom";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useFetchContext } from "../../Context/FetchContext";
import WsConfirmAlert from "../WsConfirmAlert/WsConfirmAlert";
import LanguageIcon from "@mui/icons-material/Language";
import ViewPastGuestDetails from "../ViewPastGuestDetails/ViewPastGuestDetails";
import ReciptIndexInput from "../ReciptIndexInputForm/ReciptIndexInput";
import Swal from "sweetalert2";
import WhatsAppMessageModal from "../WhatsAppMessageModal/WhatsAppMessageModal";

const CurrentGuestTableForm = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDeleteCard, setOpenDeleteCard] = useState(false);
  const [openViewDetals, setOpenViewDetails] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [details, setDetails] = useState({});
  const location = useLocation();
  const [wsConfirmAlert, setWsConfirmAlert] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [catchRefNumber, setCatchRefNumber] = useState("");
  const [registeredDate, setRegisteredData] = useState(null);
  const [openWappModal, setOpenWappModal] = useState(false);
  const [selectedWappItem, setSelectedWappItem] = useState(null);

  // const shouldRefresh = location.state?.refresh;

  const ref_Num = location.state?.referenceNumber;
  const registerdDateto = location.state?.date;

  useEffect(() => {
    if (location.state?.open === true) {
      setOpenModal(true);
      setCatchRefNumber(ref_Num);

      const dateValue = location.state?.date
        ? new Date(location.state.date)
        : null;
      setRegisteredData(dateValue);
    }
  }, [location.state?.open]);

  const filteredForms = forms.filter((item) => {
    const matchesName = searchTerm
      ? item.Customer_Fname.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.Customer_Lname.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.Refference_Number.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.Contact_Number.toLowerCase().includes(searchTerm.toLowerCase())
      : true;

    const itemDate = item.Arriving_DateTime
      ? dayjs(item.Arriving_DateTime).format("YYYY-MM-DD")
      : "";

    const startDateObj = startDate ? format(startDate, "yyyy-MM-dd") : "";
    const endDateObj = endDate ? format(endDate, "yyyy-MM-dd") : "";

    const matchesDateRange =
      (!startDate || itemDate >= startDateObj) &&
      (!endDate || itemDate <= endDateObj);

    return matchesName && matchesDateRange;
  });

  const handleOpenCard = (item) => {
    setSelectedItem(item);
    setOpenDeleteCard(true);
  };

  const handleOpenViewDetaisl = (item) => {
    setSelectedItem(item);
    setOpenViewDetails(true);
  };

  const handleCloseCard = () => {
    setOpenDeleteCard(false);
  };

  const showConfirmAlert = () => {
    return Swal.fire({
      title: "Are you sure?",
      text: "Do you want to mark this as checked out?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, mark as checked out",
      cancelButtonText: "Cancel",
      customClass: {
        actions: "swal-actions-gap",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });
  };

  const handleDone = async (item) => {
    const result = await showConfirmAlert();

    if (!result.isConfirmed) return;

    setLoading(true);

    try {
      const response = await AllServices.doneCustomer(item);
      if (response.data.succuss) {
        toast.success(response.data.message);
        await fetchForms();
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setWsConfirmAlert(false);
    setOpenModal(false);
  };

  //fetch forms
  const fetchForms = async () => {
    setLoading(true);
    try {
      const response = await AllServices.getConfirmAllReferenceDetails();

      const data = response.data.message;

      // update both forms and details with fresh data
      setForms(Array.isArray(data) ? data : []);
      setDetails(Array.isArray(data) ? data : []);
    } catch (error) {
      toast.error("There is an error fetching the Customer forms");
      setForms([]);
      setDetails([]);
    } finally {
      setLoading(false);
    }
  };

  //fetch details
  const fetchDetails = async (refNum) => {
    setLoading(true);
    try {
      const details = await AllServices.gellAllCustomerDetailsById(refNum);
      if (details.data.succuss) {
        setDetails(details.data.message);
        setOpenViewDetails(true);
        setSelectedItem(refNum);
      } else {
        toast.error(details.data.message);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchForms();
  }, []);

  //   useEffect(() => {
  //     if (refresh) {
  //       fetchForms();
  //     }
  //   }, [refresh]);

  //   useEffect(() => {
  //     if (shouldRefresh) {
  //       fetchForms();
  //     }
  //   }, [shouldRefresh]);

  //   useEffect(() => {
  //     if (shouldFetch) {
  //       fetchForms();
  //       setShouldFetch(false);
  //     }
  //   }, [shouldFetch]);

  // disble back way after adding webportal
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const blockBack = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", blockBack);
    return () => {
      window.removeEventListener("popstate", blockBack);
    };
  }, []);

  return (
    <div className="cuuerent-guest-table-Form-containor">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}

      {wsConfirmAlert && (
        <div className="loader-overlay">
          <WsConfirmAlert
            name={displayName}
            refNumber={refNumber}
            onClose={handleClose}
          />
        </div>
      )}

      {openModal && (
        <div className="loader-overlay">
          <ReciptIndexInput
            refNumber={catchRefNumber}
            registerdDate={registeredDate}
            onClose={handleClose}
          />
        </div>
      )}

      <div className="filter-containor">
        {/* Filter by */}
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="field"
        />

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={(newValue) => {
              setStartDate(newValue);
            }}
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField {...params} size="small" className="field" />
            )}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={(newValue) => {
              setEndDate(newValue);
            }}
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField {...params} size="small" className="field" />
            )}
          />
        </LocalizationProvider>
      </div>

      <TableContainer component={Paper} className="table-containor">
        <Table className="table">
          <TableHead className="table-head">
            <TableRow className="table-row">
              <TableCell className="table-cell">Reference No</TableCell>
              <TableCell className="table-cell">First Name</TableCell>
              <TableCell className="table-cell">Last Name</TableCell>
              <TableCell className="table-cell">Mobile No</TableCell>
              <TableCell className="table-cell">Arrived Date</TableCell>
              <TableCell className="table-cell">Depature Date</TableCell>
              <TableCell className="table-cell">Num Of Adults</TableCell>
              <TableCell className="table-cell">Num Of Kids</TableCell>
              <TableCell className="table-cell">WA Messages</TableCell>
              <TableCell className="table-cell">Status</TableCell>
              <TableCell className="table-cell">Checked Out</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {filteredForms.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No matching records found
                </TableCell>
              </TableRow>
            ) : (
              filteredForms.map((item) => (
                <TableRow className="table-row-body" key={item.ID}>
                  <TableCell className="table-cell ref">
                    {item.Refference_Number}
                  </TableCell>
                  <TableCell className="table-cell">
                    {item.Customer_Fname}
                  </TableCell>
                  <TableCell className="table-cell">
                    {item.Customer_Lname}
                  </TableCell>
                  <TableCell className="table-cell">
                    {item.Contact_Number}
                  </TableCell>
                  {/* <TableCell>{item.Arriving_DateTime}</TableCell> */}
                  <TableCell className="table-cell">
                    {dayjs(item.Arriving_DateTime).format("YYYY-MM-DD")}
                  </TableCell>

                  <TableCell className="table-cell">
                    {dayjs(item.Depature_DateTime).format("YYYY-MM-DD")}
                  </TableCell>

                  <TableCell className="table-cell">
                    {item.Num_Of_Adults}
                  </TableCell>
                  <TableCell className="table-cell">
                    {item.Num_Of_Kids}
                  </TableCell>
                  <TableCell className="table-cell">
                    <button
                      className="icon-wrapper WA"
                      onClick={() => {
                        setSelectedWappItem(item);
                        setOpenWappModal(true);
                      }}
                      type="button"
                    >
                      <WhatsAppIcon className="icon" />
                      <span>WhatsApp</span>
                    </button>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        padding: "4px 10px",
                        borderRadius: "50px",
                        backgroundColor: "rgba(16, 185, 129, 0.15)",
                        color: "#059669",
                        fontWeight: "600",
                        fontSize: "11px",
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                        textAlign: "center",
                        display: "inline-block",
                        minWidth: "75px",
                      }}
                    >
                      {item.Status}
                    </Box>
                  </TableCell>

                  <TableCell className="table-cell">
                    <button
                      className="icon-wrapper verified"
                      onClick={
                        item.Status === status.pending ||
                        item.Status === status.processing
                          ? undefined
                          : () => handleDone(item.Refference_Number)
                      }
                      disabled={
                        item.Status === status.pending ||
                        item.Status === status.processing
                      }
                      type="button"
                    >
                      <VerifiedUserIcon className="icon" />
                      <span>Check Out</span>
                    </button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {openDeleteCard && (
        <div className="loader-overlay">
          <ConfirmationCard
            onClose={() => setOpenDeleteCard(false)}
            item={selectedItem}
            onDeleteSuccess={fetchForms}
          />
        </div>
      )}
      {openViewDetals && (
        <div className="loader-overlay">
          <ViewPastGuestDetails
            refNum={selectedItem}
            onDetails={details}
            onClose={() => {
              setOpenViewDetails(false);
            }}
            onConfirmSuccess={fetchForms}
          />
        </div>
      )}
      {openWappModal && (
        <div className="loader-overlay">
          <WhatsAppMessageModal
            item={selectedWappItem}
            onClose={() => setOpenWappModal(false)}
            isCurrentGuest={true}
          />
        </div>
      )}
    </div>
  );
};

export default CurrentGuestTableForm;
